<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">Configuration warning!</h4>
    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="hide()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>

  <div class="modal-body">
    <img class="mascot" src="/client/assets/images/mascot/oh.svg" alt="mascot" />

    <p i18n>You enabled user registration on your instance but did not configure the following fields:</p>

    <ul>
      <li i18n *ngIf="about.instance.name.toLowerCase() === 'peertube'">Instance name</li>
      <li i18n *ngIf="isDefaultShortDescription(about.instance.shortDescription)">Instance short description</li>

      <li i18n *ngIf="!about.instance.administrator">Who you are</li>
      <li i18n *ngIf="!about.instance.maintenanceLifetime">How long you plan to maintain your instance</li>
      <li i18n *ngIf="!about.instance.businessModel">How you plan to pay for keeping your instance running</li>

      <li i18n *ngIf="!about.instance.moderationInformation">How you will moderate your instance</li>
      <li i18n *ngIf="!about.instance.terms">Instance terms</li>
    </ul>

    <p i18n>
      Please consider configuring these fields to help people to choose <strong>the appropriate instance</strong>.
      Without them, your instance may not be referenced on the <a target="_blank" rel="noopener noreferrer" href="https://joinpeertube.org">JoinPeerTube website</a>.
    </p>
  </div>

  <div class="modal-footer inputs">
    <my-peertube-checkbox
      inputName="stopDisplayModal" [(ngModel)]="stopDisplayModal"
      i18n-labelText labelText="Don't show me this warning anymore"
    >
    </my-peertube-checkbox>

    <input
      type="button" role="button" i18n-value value="Close" class="peertube-button grey-button"
      (click)="hide()" (key.enter)="hide()"
    >

    <a i18n class="peertube-button-link orange-button" ngbAutofocus
       href="/admin/config/edit-custom" target="_blank" rel="noopener noreferrer">
       Configure
    </a>
  </div>

</ng-template>
